import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { emptyCellOneLevel, useTableFilter } from "@/shared";
import { useFetchRetenciones, useUpdateRetencion } from "@/shared/actions/erp";
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";
import { Retencion } from "@/shared/interfaces";

import { useNavigate } from "react-router-dom";
import { useUiConfirmModalStore } from "@/store/ui";

const returnUrlRetencion = "/compras/retencion-compra";

export interface RetencionesPageInterface {}

const RetencionesPage: React.FC<RetencionesPageInterface> = () => {
 /*  useCheckPermissions(PermissionsEnum.api_view_Retencion) */


  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: RetencionesPagingRes,
    isLoading,
    isRefetching,
  } = useFetchRetenciones({
    page: pageIndex + 1,
    codigo: searchTerm,
  });
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
const setConfirmDialogIsOpen = useUiConfirmModalStore(
  s => s.setConfirmDialogIsOpen
);

  ///* columns
  const updateRetencion = useUpdateRetencion({
    navigate,
    returnUrl:returnUrlRetencion,
  }
  )
  const columns = useMemo<MRT_ColumnDef<Retencion>[]>(
    () => [
    {
      accessorKey:"codigo",
      header: "codigo",
      size: 300,
    },
    {
      accessorKey: "fecha_emision",
      header: "fecha de emision",
      size: 300,
    },
    {
      accessorKey: "aurorizacion",
      header: "autorización",
      size: 300,
    },
      {
        accessorKey: "concepto",
        header: "concepto",
        size: 300,
      }, 
      {
        accessorKey: "fecha_ingreso",
        header: "fecha ingreso",
        size: 180,
        Cell: ({ row }) => emptyCellOneLevel(row, "fecha_ingreso"),
      },
      {
        accessorKey: "fecha_caducidad",
        header: "fecha caducidad",
        size: 300,
      },
      {
        accessorKey: "numero_retencion",
        header: "numero retencion",
        size: 300,
      },
      {
        accessorKey: "serie_retencion",
        header: "serie retencion",
        size: 300,
      },
      {
        accessorKey: "base_imponible_iva",
        header: "base imponible iva",
        size: 300,
      },
      {
        accessorKey: "base_imponible_ice",
        header: "base imponible ice",
        size: 300,
      },
      {
        accessorKey: "base_imponible_ir",
        header: "base imponible ir",
        size: 300,
      },
      {
        accessorKey: 'asumir_retencion',
        header: 'asumir retencion',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.asumir_retencion!}
            titulo={row.original.asumir_retencion ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={retencion => {
             /*  if (!hasPermission(PermissionsEnum.api_change_Retencion)) return; */
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar retencion',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateRetencion.mutate({
                    id: row.original.id_retencion!,
                    data: {
                      ...row.original,
                      estado: retencion as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
      {
        accessorKey: 'es_fisica',
        header: 'es fisica',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.es_fisica!}
            titulo={row.original.es_fisica ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={fisica => {
             /*  if (!hasPermission(PermissionsEnum.api_change_Retencion)) return; */
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado fisico',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateRetencion.mutate({
                    id: row.original.id_retencion!,
                    data: {
                      ...row.original,
                      estado: fisica as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
      {
        accessorKey: 'asumir_retencion',
        header: 'asumir retencion',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.asumir_retencion!}
            titulo={row.original.asumir_retencion ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={retencion => {
             /*  if (!hasPermission(PermissionsEnum.api_change_Retencion)) return; */
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar asumir retencion',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateRetencion.mutate({
                    id: row.original.id_retencion!,
                    data: {
                      ...row.original,
                      estado: retencion as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <SwitchComponente
            estadoSwitch={row.original.estado!}
            titulo={row.original.estado ? 'Activo' : 'Inactivo'}
            setEstadoSwitch={activo => {
             /*  if (!hasPermission(PermissionsEnum.api_change_Retencion)) return; */
              setConfirmDialog({
                isOpen: true,
                title: 'Cambiar Estado',
                subtitle:
                  '¿Está seguro que desea cambiar el estado de este registro ?',
                onConfirm: () => {
                  setConfirmDialogIsOpen(false);
                  updateRetencion.mutate({
                    id: row.original.id_retencion!,
                    data: {
                      ...row.original,
                      estado: activo as boolean,
                    },
                  });
                },
              });
            }}
          />
        ),
      }   
    ],
    []
  );
  return (
    <SingleTableBoxScene title="Retenciones" urlRedirect={`${returnUrlRetencion}/crear`} /* showCreateBtn={hasPermission(PermissionsEnum.api_add_Retencion)} */>
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="Retenciones"
      />

      <GeneralTable<Retencion>
        columns={columns}
        data={RetencionesPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={RetencionesPagingRes?.data?.count}
        // // actions 
       /*  enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_Retencion,
        ])} */
        actionsColumnSize={120}
        // crud
        enableEditing={false}
        canDelete={false}
        positionActionsColumn='first'
      />
       
    </SingleTableBoxScene>
  );
};

export default RetencionesPage;
